export enum LayoutOrientation {
  UNCONSTRAINED = 'unconstrained',
  LEFT_TO_RIGHT = 'leftToRight',
  TOP_TO_BOTTOM = 'topToBottom',
  RIGHT_TO_LEFT = 'rightToLeft',
  BOTTOM_TO_TOP = 'bottomToTop'
}
